import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab } from "components/general/Tab";
import { Tabs } from "components/general/Tabs";
import Cursos from "../../assets/data/cursos/index.json"
import { Helmet } from "react-helmet";
import Styles from "views/pages/CursosOnline.module.scss";

class CursosOnline extends Component {

  constructor(props) {
    super(props);

    this.state = {
      current: 0,
      currentQuestion: 0,
      openMobileList: false,
      showMobileContent: true
    }

    this.categories = this.categories.bind(this);
    this.listMobileActive = this.listMobileActive.bind(this);
    this.listMobileClose = this.listMobileClose.bind(this);
  }

  categories(k) {

    this.setState({
      current: k,
      currentQuestion: 0
    });
  }

  subCategory(k) {
    return () => {
      this.setState({
        currentQuestion: k,
        openMobileList: false,
        showMobileContent: true
      });
    }
  }

  listMobileActive() {
    return () => {
      this.setState({ openMobileList: true, showMobileContent: false });
    }
  }

  listMobileClose() {
    return () => {
      this.setState({ openMobileList: false, showMobileContent: true });
    }
  }

  componentDidMount() {
    const {
      person,
      history
    } = this.props;

    if (person.person.personStatus !== 4 && person.person.personStatus !== 14) {
      history.push("/beneficios");
    }
  }

  renderCoursesPreviewsList = () => {
    return Cursos.map((item, key) => {
      return (
        <Tab label={item.tabLabel} tabId={item.slug} key={key}>
          <div>
            {this.renderPageDescription()}
          </div>
          <div className={Styles["preview-container"]}>
            {this.renderCoursesPreviews(item.slug, item.courses)}
          </div>
        </Tab>
      );
    })
  }

  renderPageDescription = () =>{
    return(
      <div  className={Styles["page-description"]}>
        <h3>Cursos disponíveis</h3>
        <p>Clique no curso para visualizar o conteúdo</p>
      </div>
    )
  }

  isFeatured = (str) => {

    if (!str) return null;

    return (
      <span className={Styles["novidade"]}>Novidade</span>
    )
  }

  renderCoursesPreviews = (slug, courses) => {

    if (!courses) return null;
    
    return courses.map((item, key) => {
     
      return (
        <div key = {key} className={Styles["preview-content"]} onClick={(e) => this.renderCoursesContents(slug, key)}>
          <div className={Styles["banner"]}>
            { this.isFeatured(item.featured) }
            <img src={item.image} alt="course-img"></img>          
          </div>
        </div>
      )
    })
  }

  renderCoursesContents = (slug, cursoIndex) => {
    const {
      history
    } = this.props;

    history.push("/cursos-online/" + slug + "/" + cursoIndex);
  }

  renderScreen = () => {
    const { match } = this.props;
    let activeTab = match.params.hasOwnProperty("tab") ? match.params.tab : null;

    if (![4, 14].includes(this.props.person.person.personStatus)) {
      return (
        <div className={"py-4"}>
          <h3 className={"mb-2 display-3"}>Ops!</h3>
          <p>Conteúdo restrito para Glamgirls com uma assinatura ativa!</p>
        </div>
      );
    }

    return (
      //<Tabs activeTab={activeTab} parentPage={"/cursos-online"}>
        this.renderCoursesPreviewsList()
      //</Tabs>
    );
  }

  render() {

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : Cursos Online</title>
        </Helmet>
        <h1>
          Cursos Online
        </h1>

        {this.renderScreen()}
      </div>

    )
  }
};

const mapStateToProps = (state) => ({
  person: state.person.data
});

const mapDispatchToProps = (dispatch) => ({
});

CursosOnline = connect(mapStateToProps, mapDispatchToProps)(CursosOnline);

export {
  CursosOnline
};
